export const Modal = ({ children, open, onClose }) => {
    // Modal should unmount fully if children is null/undefined/false
    if (!children) return null;
    return (
      <div  onClick={onClose}>
        <div onClick={e => e.stopPropagation()}>
          {children}
        </div>
      </div>
    );
  };